module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iterators.js
// module id = 64
// module chunks = 2